module.exports = __webpack_public_path__ + "img/蒙版分组.0a1a2e01.png";